// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TSxBG","img":"styles_img__cg1N3"};